import { useEffect } from 'react';
import useCommonToast from './useCommonToast';

export function useToastNotification({ showToast, title, message, status = 'error', onAfterShowToast = () => {} }) {
    const { toast } = useCommonToast();

    useEffect(() => {
        if (showToast) {
            toast({
                title,
                message,
                status,
                isClosable: true,
            });
            onAfterShowToast();
        }
    }, [showToast, title, message, status, toast, onAfterShowToast]);

    return null;
}
